import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const alumnosGrupoPdf = ({ grupo, alumnos, empresa }) => {
  const escuelaNombre = grupo?.escuela?.nombre || "";
  const escuelaClave = grupo?.escuela?.clave || "";
  const fecha = moment().format("DD/MM/YYYY HH:mm");

  const nombreEmpresa = empresa
    ? empresa.persona
      ? empresa.nombre
      : `${empresa.nombre || ""} ${empresa.apellidoPaterno || ""} ${empresa.apellidoMaterno || ""}`.trim()
    : "";

  const filasMeta = [
    [
      { text: "Escuela:", style: "metaLabel" },
      {
        text: escuelaNombre + (escuelaClave ? ` (${escuelaClave})` : ""),
        style: "metaValue",
      },
      { text: "Grupo:", style: "metaLabel" },
      { text: grupo?.nombre || "—", style: "metaValue" },
    ],
    [
      { text: "Nivel:", style: "metaLabel" },
      { text: grupo?.nivelEducativo || "—", style: "metaValue" },
      { text: "Grado:", style: "metaLabel" },
      { text: grupo?.grado || "—", style: "metaValue" },
    ],
    [
      { text: "Programa:", style: "metaLabel" },
      { text: grupo?.programaEducativo || "—", style: "metaValue" },
      { text: "Total alumnos:", style: "metaLabel" },
      { text: String((alumnos || []).length), style: "metaValue" },
    ],
  ];

  const headerTabla = [
    { text: "#", style: "thHeader", alignment: "center" },
    { text: "Matrícula", style: "thHeader" },
    { text: "Nombre", style: "thHeader" },
    { text: "Nivel Prepare", style: "thHeader" },
    { text: "Nivel Inglés", style: "thHeader", alignment: "center" },
    { text: "Correo", style: "thHeader" },
    { text: "Teléfono", style: "thHeader" },
  ];

  const filasAlumnos = (alumnos || []).map((a, i) => [
    { text: String(i + 1), style: "tdCell", alignment: "center" },
    { text: a.matricula || "", style: "tdCell" },
    {
      text: [a.nombre, a.apellidoPaterno, a.apellidoMaterno]
        .filter(Boolean)
        .join(" "),
      style: "tdCell",
    },
    { text: a.nivelPrepare || "", style: "tdCell" },
    {
      text: a.nivelIngles == null ? "" : String(a.nivelIngles),
      style: "tdCell",
      alignment: "center",
    },
    { text: a.correo || "", style: "tdCell" },
    { text: a.telefono || a.celular || "", style: "tdCell" },
  ]);

  if (filasAlumnos.length === 0) {
    filasAlumnos.push([
      {
        text: "Este grupo no tiene alumnos asignados",
        colSpan: 7,
        alignment: "center",
        italics: true,
        style: "tdCell",
      },
      {},
      {},
      {},
      {},
      {},
      {},
    ]);
  }

  return {
    pageSize: "LETTER",
    pageOrientation: "landscape",
    pageMargins: [30, 35, 30, 40],
    info: {
      title: `Lista de alumnos - ${grupo?.nombre || ""}`,
      author: nombreEmpresa || "ERP",
    },
    content: [
      {
        columns: [
          [
            { text: "Lista de alumnos", style: "titulo" },
            nombreEmpresa
              ? { text: nombreEmpresa, style: "subtitulo" }
              : { text: "" },
          ],
          {
            text: `Generado: ${fecha}`,
            style: "fechaHeader",
            alignment: "right",
          },
        ],
        margin: [0, 0, 0, 12],
      },
      {
        table: {
          widths: ["18%", "32%", "18%", "32%"],
          body: filasMeta,
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0,
          hLineColor: () => "#cccccc",
          paddingTop: () => 4,
          paddingBottom: () => 4,
          paddingLeft: () => 6,
          paddingRight: () => 6,
        },
        margin: [0, 0, 0, 14],
      },
      {
        table: {
          headerRows: 1,
          widths: [22, 70, "*", 65, 50, "*", 70],
          body: [headerTabla, ...filasAlumnos],
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => "#999999",
          vLineColor: () => "#999999",
          fillColor: (rowIndex) =>
            rowIndex === 0
              ? "#e8e8e8"
              : rowIndex % 2 === 0
                ? "#fafafa"
                : null,
          paddingTop: () => 4,
          paddingBottom: () => 4,
          paddingLeft: () => 5,
          paddingRight: () => 5,
        },
      },
    ],
    footer: (currentPage, pageCount) => ({
      columns: [
        {
          text: `Lista de alumnos · ${grupo?.nombre || ""}`,
          alignment: "left",
          fontSize: 8,
          color: "#888",
          margin: [30, 0, 0, 0],
        },
        {
          text: `Página ${currentPage} de ${pageCount}`,
          alignment: "right",
          fontSize: 8,
          color: "#888",
          margin: [0, 0, 30, 0],
        },
      ],
    }),
    defaultStyle: { fontSize: 9 },
    styles: {
      titulo: { fontSize: 16, bold: true },
      subtitulo: { fontSize: 10, color: "#555" },
      fechaHeader: { fontSize: 9, color: "#666" },
      metaLabel: { bold: true, fontSize: 9 },
      metaValue: { fontSize: 9 },
      thHeader: { bold: true, fontSize: 9 },
      tdCell: { fontSize: 9 },
    },
  };
};

export default alumnosGrupoPdf;
